import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import { __assign, __awaiter, __generator, __read, __spread, __values } from "tslib";
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Confirmable } from '@/lib/script/confirmable';
var m = {
  namespaced: true,
  state: function state() {
    return {
      user_id: '',
      basicInfo: null,
      basicInfoMap: {},
      stats: {},
      setting: null,
      personalInfo: null,
      hasRecordNotify11: null,
      creditRecord: {
        list: [],
        requesting: false,
        loaded: false
      },
      creditInfo: {
        count: 0,
        remark: ''
      },
      moments: {},
      homeMedal: {},
      homeData: {},
      follow: {
        list: [],
        loaded: false,
        requesting: false
      },
      followMap: {},
      fan: {
        list: [],
        loaded: false,
        requesting: false
      },
      fanMap: {},
      followInfo: {},
      wthdrawalAlert: null,
      sentence: []
    };
  },
  mutations: {
    /**
     * 记录用户基础信息
     */
    setBasicInfo: function setBasicInfo(state, basicInfo) {
      state.basicInfo = basicInfo;

      if (basicInfo) {
        Sentry.configureScope(function (scope) {
          scope.setUser({
            id: basicInfo.id
          });
        });
        aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['_user_id', basicInfo.id]
        }); // gio('setUserId', basicInfo.id);
        // gio('people.set', 'mobile_bound', basicInfo.mobile_bound ? '1' : '0');
      }
    },

    /**
     * 记录用户基础信息
     */
    setBasicInfoMap: function setBasicInfoMap(state, _a) {
      var id = _a.id,
          info = _a.info;
      Vue.set(state.basicInfoMap, id, info);
    },
    setBasicInfoHasFollow: function setBasicInfoHasFollow(state, _a) {
      var userId = _a.userId,
          hasFollow = _a.hasFollow;
      var info = state.basicInfoMap[userId];

      if (info) {
        info.has_follow = hasFollow;
      }
    },

    /**
     * 记录数据
     */
    setStats: function setStats(state, _a) {
      var userId = _a.userId,
          stats = _a.stats;
      Vue.set(state.stats, userId, stats);
    },

    /**
     * 记录setting
     */
    setSetting: function setSetting(state, setting) {
      state.setting = setting;
    },

    /**
     * 记录personalInfo
     */
    setPersonalInfo: function setPersonalInfo(state, personalInfo) {
      state.personalInfo = personalInfo;
    },

    /**
     * 记录通知11上线
     */
    setRecordNotify11: function setRecordNotify11(state, notify11) {
      state.hasRecordNotify11 = notify11;
    },

    /**
     * 记录信用分记录列表
     * @param {} list
     */
    concatCreditRecord: function concatCreditRecord(state, list) {
      state.creditRecord.list = state.creditRecord.list.concat(list);
    },
    setCreditRecordRequest: function setCreditRecordRequest(state, data) {
      state.creditRecord.requesting = data;
    },
    setCreditRecordLoaded: function setCreditRecordLoaded(state, data) {
      state.creditRecord.loaded = data;
    },
    setCreditInfo: function setCreditInfo(state, info) {
      state.creditInfo = info;
    },

    /**
     * 记录奖牌数据
     */
    setHomeMedal: function setHomeMedal(state, _a) {
      var userId = _a.userId,
          medal = _a.medal;
      Vue.set(state.homeMedal, userId, medal);
    },

    /**
     * 记录关注/粉丝等数据
     */
    setHomeData: function setHomeData(state, _a) {
      var userId = _a.userId,
          data = _a.data;
      Vue.set(state.homeData, userId, data);
    },

    /**
     * 关注列表
     */
    initFollow: function initFollow(state) {
      state.follow.list = [];
      state.follow.loaded = false;
      state.follow.requesting = false;
    },
    concatFollow: function concatFollow(state, _a) {
      var e_1, _b, _c;

      var list = _a.list;
      var ids = [];

      try {
        for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
          var item = list_1_1.value;
          ids.push(item.id);
          item.follow = true;
          Vue.set(state.followMap, item.id, item);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (list_1_1 && !list_1_1.done && (_b = list_1["return"])) _b.call(list_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      (_c = state.follow.list).push.apply(_c, __spread(ids));
    },
    setFollowLoaded: function setFollowLoaded(state, _a) {
      var loaded = _a.loaded;
      state.follow.loaded = loaded;
    },
    setFollowReq: function setFollowReq(state, _a) {
      var req = _a.req;
      state.follow.requesting = req;
    },
    setFollowHasFollow: function setFollowHasFollow(state, _a) {
      var userId = _a.userId,
          follow = _a.follow;
      var item = state.followMap[userId];

      if (item) {
        item.follow = follow;
      }
    },

    /**
     * 粉丝列表
     */
    concatFan: function concatFan(state, _a) {
      var e_2, _b, _c;

      var list = _a.list;
      var ids = [];

      try {
        for (var list_2 = __values(list), list_2_1 = list_2.next(); !list_2_1.done; list_2_1 = list_2.next()) {
          var item = list_2_1.value;
          ids.push(item.id);
          Vue.set(state.fanMap, item.id, item);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (list_2_1 && !list_2_1.done && (_b = list_2["return"])) _b.call(list_2);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      (_c = state.fan.list).push.apply(_c, __spread(ids));
    },
    setFanLoaded: function setFanLoaded(state, _a) {
      var loaded = _a.loaded;
      state.fan.loaded = loaded;
    },
    setWithdrawalAlert: function setWithdrawalAlert(state, wthdrawalAlert) {
      state.wthdrawalAlert = wthdrawalAlert;
    },
    setFanReq: function setFanReq(state, _a) {
      var req = _a.req;
      state.fan.requesting = req;
    },
    setFanHasFollow: function setFanHasFollow(state, _a) {
      var userId = _a.userId,
          hasFollow = _a.hasFollow;
      var item = state.fanMap[userId];

      if (item) {
        item.has_follow = hasFollow;
      }
    },
    setFollowInfo: function setFollowInfo(state, _a) {
      var userId = _a.userId,
          hasFollow = _a.hasFollow;
      state.user_id = userId;
      Vue.set(state.followInfo, userId, hasFollow);
    },
    setSentence: function setSentence(state, sentence) {
      state.sentence = sentence;
    }
  },
  actions: {
    /**
     * 获取用户基本数据
     * @param id 如果不传则获取自己的数据
     */
    getBasicInfo: function getBasicInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          id = _c.id,
          forceUpdate = _c.forceUpdate;

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/basic_info', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;

                if (!id) {
                  commit('setBasicInfo', data);
                } else {
                  commit('user/setFollowInfo', {
                    userId: data.id,
                    hasFollow: data.has_follow
                  }, {
                    root: true
                  });
                }

                commit('setBasicInfoMap', {
                  id: id,
                  info: data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取统计数据，例如总打卡天数，总距离
     */
    getStats: function getStats(_a, _b) {
      var _c;

      var state = _a.state,
          commit = _a.commit,
          rootState = _a.rootState;
      var userId = (_b === void 0 ? {} : _b).userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!userId) {
                userId = (_c = rootState.user.basicInfo) === null || _c === void 0 ? void 0 : _c.id;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/stats', {
                params: {
                  id: userId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStats', {
                  userId: userId,
                  stats: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取设置
     */
    getSetting: function getSetting(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/settings')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setSetting', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新设置
     */
    updateSetting: function updateSetting(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var key = _b.key,
          value = _b.value;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/settings', {
                key: key,
                value: value
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 实名认证申请
     */
    initRealNameVerify: function initRealNameVerify(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var name = _b.name,
          idCard = _b.idCard,
          mobile = _b.mobile;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/init_real_name_verify', {
                name: name,
                id_card: idCard,
                mobile: mobile
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 实名认证确认
     */
    checkRealNameVerify: function checkRealNameVerify(_a, _b) {
      var dispatch = _a.dispatch;
      var token = _b.token,
          code = _b.code;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/check_real_name_verify', {
                token: token,
                code: code
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , dispatch({
                type: 'getBasicInfo',
                forceUpdate: true
              })];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 登录验证码
     */
    getVerificateCode: function getVerificateCode(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var areaCode = _b.areaCode,
          mobile = _b.mobile;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/bind_mobile', {
                area_code: areaCode,
                mobile: mobile
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 绑定手机
     */
    bindingPhone: function bindingPhone(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var serialNumber = _b.serialNumber,
          code = _b.code;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/confirm_mobile', {
                serial_number: serialNumber,
                code: code
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 绑定邀请人
     */
    recordReferrer: function recordReferrer(_a, referrer) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/record_referrer', {
                user_id: referrer
              })];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 获取用户信息
     */
    getPersonalInfo: function getPersonalInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.personalInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/user_info')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                data.avatar = {
                  key: data.avatar,
                  url: data.avatar_url
                };
                delete data.avatar_url;
                data.district = [data.district_1_id, data.district_2_id, data.district_3_id];
                delete data.district_1_id;
                delete data.district_2_id;
                delete data.district_3_id;
                commit('setPersonalInfo', new Confirmable(rdata.data));
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户信息
     * @param activity_id 选填
     */
    updatePersonalInfo: function updatePersonalInfo(_a, _b) {
      var _c;

      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;

      var _d = _b === void 0 ? {} : _b,
          activityId = _d.activityId,
          forceUpdate = _d.forceUpdate;

      return __awaiter(this, void 0, void 0, function () {
        var info, response, rdata;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              dispatch('getPersonalInfo');
              info = state.personalInfo;
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/user_info', __assign(__assign({
                activity_id: activityId
              }, info), {
                avatar: (_c = info === null || info === void 0 ? void 0 : info.avatar) === null || _c === void 0 ? void 0 : _c.key,
                district_1_id: info === null || info === void 0 ? void 0 : info.district[0],
                district_2_id: info === null || info === void 0 ? void 0 : info.district[1],
                district_3_id: info === null || info === void 0 ? void 0 : info.district[2]
              }))];

            case 1:
              response = _e.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                // @ts-ignore
                info.confirm();
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 记录通知11届
     */
    recordNotify11: function recordNotify11(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var mobile = _b.mobile,
          areaCode = _b.areaCode,
          mobileBound = _b.mobileBound,
          requireBound = _b.requireBound;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/record_notify_11', {
                mobile: mobile,
                area_code: areaCode,
                mobile_bound: mobileBound,
                require_bound: requireBound
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getRecordNotify11: function getRecordNotify11(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/record_notify_11')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRecordNotify11', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户信用分
     */
    getCreditInfo: function getCreditInfo(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/credit/info')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCreditInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户信用分列表
     */
    getCreditRecord: function getCreditRecord(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var lastId = _b.lastId,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.creditRecord;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
              }

              commit('setCreditRecordRequest', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/credit/detail', {
                params: {
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatCreditRecord', rdata.data);

                if (rdata.data.length < count) {
                  commit('setCreditRecordLoaded', true);
                }
              }

              commit('setCreditRecordRequest', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取奖牌
     */
    getHomeMedal: function getHomeMedal(context, _a) {
      var userId = (_a === void 0 ? {} : _a).userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!userId) {
                userId = context.rootState.user.basicInfo.id;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/activity/medal', {
                params: {
                  id: userId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setHomeMedal', {
                  userId: userId,
                  medal: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取关注/粉丝等数据
     */
    getHomeData: function getHomeData(context, _a) {
      var userId = (_a === void 0 ? {} : _a).userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!userId) {
                userId = context.rootState.user.basicInfo.id;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/home_data', {
                params: {
                  id: userId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setHomeData', {
                  userId: userId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 关注
     */
    follow: function follow(context, _a) {
      var userId = _a.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/follow', {
                id: userId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setFollowInfo', {
                  userId: userId,
                  hasFollow: true
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 取消关注
     */
    cancelFollow: function cancelFollow(context, _a) {
      var userId = _a.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/cancel_follow', {
                id: userId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setFollowInfo', {
                  userId: userId,
                  hasFollow: false
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取关注列表
     */
    getFollowList: function getFollowList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list, list_3, list_3_1, item;

        var e_3, _c;

        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.follow;

              if (wrap.loaded && !forceUpdate || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.list = [];
                offset = 0;
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setFollowReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/follow', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;

                try {
                  for (list_3 = __values(list), list_3_1 = list_3.next(); !list_3_1.done; list_3_1 = list_3.next()) {
                    item = list_3_1.value;
                    commit('user/setFollowInfo', {
                      userId: item.id,
                      hasFollow: true
                    }, {
                      root: true
                    });
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (list_3_1 && !list_3_1.done && (_c = list_3["return"])) _c.call(list_3);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }

                commit('concatFollow', {
                  list: list
                });

                if (list.length < count) {
                  commit('setFollowLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setFollowReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取粉丝列表
     */
    getFanList: function getFanList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list, list_4, list_4_1, item;

        var e_4, _c;

        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.fan;

              if (wrap.loaded && !forceUpdate || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.list = [];
                offset = 0;
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setFanReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/fans', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;

                try {
                  for (list_4 = __values(list), list_4_1 = list_4.next(); !list_4_1.done; list_4_1 = list_4.next()) {
                    item = list_4_1.value;
                    commit('user/setFollowInfo', {
                      userId: item.id,
                      hasFollow: item.has_follow
                    }, {
                      root: true
                    });
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (list_4_1 && !list_4_1.done && (_c = list_4["return"])) _c.call(list_4);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }

                commit('concatFan', {
                  list: list
                });

                if (list.length < count) {
                  commit('setFanLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setFanReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getUserAlert: function getUserAlert() {
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/alert')];

            case 1:
              res = _a.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getWithdrawalAlert: function getWithdrawalAlert(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/withdrawal_alert')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWithdrawalAlert', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    addAlert: function addAlert() {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/triangle/add_alert')];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getSentence: function getSentence(context, _a) {
      var date = _a.date,
          activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/sentence', {
                params: {
                  date: date,
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setSentence', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    updateSentence: function updateSentence(context, _a) {
      var date = _a.date,
          sentence = _a.sentence,
          image = _a.image,
          activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/sentence', {
                date: date,
                sentence: sentence,
                image: image,
                activity_id: activityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;